import { Form } from 'antd';
import Box from 'components/Box';
import { useSetLoadingPage } from 'services/UI/LoadingPage';
import styled from 'styled-components';
import ActionButtons from '../PaymentTabMenu/components/ActionButtons';
import SectionV2 from '../PaymentTabMenu/components/SectionV2';
import SwitchBtn from '../ServicesSettingV2/SwitchBtn';
import DayOfWeek from './components/DayOfWeek';
import StaffApply from './components/StaffApply';
import { useEffect } from 'react';
import { getMessageError, IResponseDataBody } from 'services/response';
import toast from 'utils/toast';
import shopApis from 'services/shop/apis';
import { ICleaningFeeResDataV2 } from 'services/shop/types/cleaning-fee';
import useGetCleaningFee from 'features/settingService/services/hooks/useGetCleaningFee';
import IcCalendarSelect from 'features/user/pages/clockInClockOut/components/IcCalendarSelect';

const CleaningFeeTab = () => {
  const [cleaningFee, mutate] = useGetCleaningFee();
  const [form] = Form.useForm<ICleaningFeeResDataV2>();
  const setLoading = useSetLoadingPage();

  useEffect(() => {
    if (cleaningFee) {
      form.setFieldsValue(cleaningFee);
    }
  }, [cleaningFee]);

  const onFinish = async (values: ICleaningFeeResDataV2) => {
    setLoading(true);
    try {
      const res: IResponseDataBody<ICleaningFeeResDataV2> = await shopApis.updateCleaningFeeV2(values);
      if (res.data.data) {
        toast.success('Cleaning fee updated successfully');
        mutate();
      }
    } catch (error) {
      const msg = getMessageError(error);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={onFinish}
      initialValues={{ enableCleaningFee: true, items: [] }}
    >
      <FormContainer>
        <Container>
          <Box display="flex" gap="3" alignItems="center">
            <FormItemStyled name="enableCleaningFee">
              <SwitchBtn />
            </FormItemStyled>
            <span className='section-label'>
              Cleaning fee
            </span>
          </Box>

          <FormItemStyled
            name={'dayActiveFee'}
            label={
              <Box display="flex" gap="3" alignItems="center">
                <IcCalendarSelect fill='#6FABB6' width={36} height={36} />
                <LabelTextStyled>
                  Select the day for the cleaning fee
                </LabelTextStyled>
              </Box>
            }
          >
            <DayOfWeek />
          </FormItemStyled>
          <StaffApply />
        </Container>
        <ActionButtons showReset={false} />
      </FormContainer>
    </Form>
  );
};

export default CleaningFeeTab;

const Container = styled(SectionV2)`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-self: stretch;
  background-color: #fff;
`;

const FormContainer = styled.div`
  background: #fff;
  padding: 16px;
`;

const FormItemStyled = styled(Form.Item)`
  margin: 0;
   align-self: stretch;
`;

const LabelTextStyled = styled.div`
  color: #64748B;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
`;